export class Platform {
    public constructor(
        public readonly id: string,
        public readonly name: string,
        public readonly hostname: string,
        public readonly prefix: string,
        public readonly isDefault: boolean,
    ) {}
}
